import { forwardRef, useImperativeHandle, useRef } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { AlignmentHtmlInteractions } from "features/alignment/alignmentHtmlInteractions";
import { ClippingPlaneInteractions } from "features/clippingPlanes/clippingPlaneInteractions";
import { CoordinatesHtmlInteractions } from "features/coordinates/coordinatesHtmlInteractions";
import { FormsTopDown } from "features/forms/formsTopDown";
import { DimensionHtmlInteractions } from "features/measure/dimensionHtmlInteractions";
import { MeasureHtmlInteractions } from "features/measure/measureHtmlInteractions";
import { selectMeasureVisible } from "features/measure/measureSlice";
import { ObjectMeasureHtmlInteractions } from "features/measure/objectMeasureHtmlInteractions";
import { LaserHtmlInteractions } from "features/outlineLaser/laserHtmlInteractions";
import { PointToPointHtmlInteractions } from "features/pointLine/pointLineHtmlInteractions";
import { SectionPlaneInteractions } from "features/sectionPlane";
import { selectIsProcoreDesign } from "slices/explorer";

export const Engine2DHtmlInteractions = forwardRef(function Engine2DHtmlInteractions(_, ref) {
    const childRefs = useRef([] as { update: () => void }[]);
    const measureVisible = useAppSelector(selectMeasureVisible);
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);

    useImperativeHandle(
        ref,
        () => ({
            update() {
                for (const childRef of childRefs.current) {
                    childRef?.update();
                }
            },
        }),
        [],
    );

    return (
        <div>
            <FormsTopDown ref={(e) => (childRefs.current[0] = e as { update: () => void })} />
            <AlignmentHtmlInteractions ref={(e) => (childRefs.current[1] = e as { update: () => void })} />
            {isProcoreDesign ? (
                <SectionPlaneInteractions ref={(e) => (childRefs.current[2] = e as { update: () => void })} />
            ) : (
                <ClippingPlaneInteractions ref={(e) => (childRefs.current[2] = e as { update: () => void })} />
            )}
            {measureVisible && (
                <>
                    <LaserHtmlInteractions ref={(e) => (childRefs.current[3] = e as { update: () => void })} />
                    <CoordinatesHtmlInteractions ref={(e) => (childRefs.current[4] = e as { update: () => void })} />
                    <PointToPointHtmlInteractions ref={(e) => (childRefs.current[5] = e as { update: () => void })} />
                    <DimensionHtmlInteractions ref={(e) => (childRefs.current[6] = e as { update: () => void })} />
                    <ObjectMeasureHtmlInteractions ref={(e) => (childRefs.current[7] = e as { update: () => void })} />
                    <MeasureHtmlInteractions />
                </>
            )}
        </div>
    );
});
